import App from './App.svelte';

const formApp = new App({
    target: document.getElementById('form-app-item-ask'),
});

export default formApp;

const event = new CustomEvent('formItemAskAppReady', {detail: formApp});

document.dispatchEvent(event);